<template>
	<div class="knd-story">
		<div class="knd-kop">
			<h1 v-html="getContent(content.kop)"></h1>
			<p class="intro" v-html="getContent(content.intro)"></p>
			<Pijl :kleur="'#fff'" />
		</div>

		<!-- strooigoed top -->

		<kinesis-container 
			:event='"scroll"' 
			:duration="1"
			class="aarde">
			<kinesis-element 
				:type='"translate"' 
				:strength="3000">
				<img :src='require("@/assets/img/aarde.png")' class="satelliet" />
				<img :src='require("@/assets/img/ellipse.png")' class="ellipse" ref="ellipse" />
			</kinesis-element>
		</kinesis-container>

		<div class="geld-wrapper">
			<kinesis-container 
				:event='"scroll"' 
				:duration="1"
				class="geld links">
				<kinesis-element 
					:type='"translate"' 
					:axis='"x"'
					:originX="-50"
					:maxX="-200"
					:strength="-500">
					<img :src='require("@/assets/img/geldlinks.png")' />
				</kinesis-element>
			</kinesis-container>


			<kinesis-container 
				:event='"scroll"' 
				:duration="1"
				class="geld rechts">
				<kinesis-element 
					:type='"translate"' 
					:axis='"x"'
					:originX="50"
					:maxX="200"
					:strength="500">
					<img :src='require("@/assets/img/geldrechts.png")' />
				</kinesis-element>
			</kinesis-container>
		</div>

		<div class="knd-strooigoed-top">

			<kinesis-container 
				:event='"scroll"' 
				:duration="1"
				class="graverbird">
				<kinesis-element 
					:type='"translate"' 
					:strength="-500">
					<kinesis-element 
						:type='"scale"' 
						:strength="-10">
						<!-- <img :src='require("@/assets/img/graverbird.png")' /> -->
						<video 
							autoplay 
							playsinline 
							loop 
							muted
							:src='require("@/assets/video/getty1.mp4")' >
							Uw browser ondersteunt het element <code>video</code> niet.
						</video>
					</kinesis-element>
				</kinesis-element>
			</kinesis-container>

			<kinesis-container 
				:event='"scroll"' 
				:duration="1"
				class="thomas">
				<kinesis-element 
					:type='"translate"'
					:axis='"x"'
					:originX="-50"
					:maxX="-200"
					:strength="-500">
					<img :src='require("@/assets/img/thomas.png")' />
				</kinesis-element>
			</kinesis-container>

			<kinesis-container 
				:event='"scroll"' 
				:duration="1"
				class="opaoma">
				<kinesis-element 
					:type='"translate"' 
					:strength="-500">
					<img :src='require("@/assets/img/opaoma.png")' />
				</kinesis-element>
			</kinesis-container>
		</div>

		<!-- introductie -->

		<div class="knd-article eerste" ref="article">
			<div class="knd-text">
				<p v-html="getContent(content.tekst[0].tekst)"></p>

				<!-- Toevoegen bij kop grafiek in datawrapper:
				<span style="color:#fff;font-family:Arial;font-size:19px;font-weight:bold;">
				-->
				
				<iframe 
					class="knd-datawrapper-grafiek"
					title="PGB belegd per pensioendeelnemer en -ontvanger de meeste euro's in fossiele industrie" 
					aria-label="Bar Chart" 
					id="datawrapper-chart-rPFtI" 
					src="https://datawrapper.dwcdn.net/rPFtI/1/" 
					scrolling="no" 
					frameborder="0" 
					style="width: 0; min-width: 100% !important; border: none;" 
					height="398" 
					data-external="1">
				</iframe>

				<p v-html="getContent(content.tekst[1].tekst)"></p>
			</div>
		</div>

		<!-- swiper -->

		<div class="knd-article tweede">
			<Swiper />

			<div class="knd-text">
				<h1 v-html="getContent(content.tekst[2].tussenkop)"></h1>
				<p v-html="getContent(content.tekst[2].tekst)"></p>
			</div>

			<kinesis-container 
				:event='"scroll"' 
				:duration="1"
				class="thomas2-wrapper">
				<kinesis-element 
					:type='"translate"' 
					:axis='"x"'
					:originX="0"
					:maxX="600"
					:strength="500">
					<img :src='require("@/assets/img/thomas2.png")' class="thomas2" />
				</kinesis-element>
			</kinesis-container>
		</div>

		<div class="knd-strooigoed-wrapper">
			<div class="knd-strooigoed">

				<kinesis-container 
					:event='"scroll"' 
					:duration="1"
					class="graveraktie" >
					<kinesis-element 
						:type='"translate"' 
						:axis='"x"'
						:originX="200"
						:maxX="0"
						:strength="-100">
						<!-- <img :src='require("@/assets/img/graveraktie.png")' /> -->
						<video 
							autoplay 
							playsinline 
							loop 
							muted
							:src='require("@/assets/video/getty2.mp4")' >
							Uw browser ondersteunt het element <code>video</code> niet.
						</video>
					</kinesis-element>
				</kinesis-container>

				<kinesis-container 
					:event='"scroll"' 
					:duration="1"
					class="opavuist">
					<kinesis-element 
						:type='"translate"' 
						:axis='"x"'
						:originX="0"
						:maxX="-200"
						:strength="-500">
						<img :src='require("@/assets/img/opavuist.png")'  />
					</kinesis-element>
				</kinesis-container>

				<kinesis-container 
					:event='"scroll"' 
					:duration="1"
					class="capaciteit">
					<kinesis-element 
						:type='"scale"' 
						:strength="-10">
						<img :src='require("@/assets/img/capaciteit.svg")' />
					</kinesis-element>
				</kinesis-container>
				

				<kinesis-container 
					:event='"scroll"' 
					:duration="1"
					class="opajuig">
					<kinesis-element 
						:type='"translate"' 
						:strength="-500">
						<img :src='require("@/assets/img/opajuig.png")' />
					</kinesis-element>
				</kinesis-container>

				<div class="quote">
					<h1 v-html="content.citaat"></h1>
					<p class="naam" v-html="content.citaat_auteur"></p>
				</div>
			</div>
		</div>

		<!-- pensioenstats -->

		<div class="knd-article derde">
			<Pensioenstats />

			<kinesis-container 
				:event='"scroll"' 
				:duration="1"
				class="opaloop-wrapper"
				v-if='getFonds() && getFonds()["pensioenfonds"] !== "StiPP"'>
				<kinesis-element 
					:type='"translate"' 
					:axis='"x"'
					:originX="0"
					:maxX="600"
					:strength="500">
					<img :src='require("@/assets/img/opaloop.png")' class="opaloop" />
				</kinesis-element>
			</kinesis-container>

			<Pensioenswarms />

			<div class="knd-text na-stats">
				<h1 v-html="getContent(content.tekst[3].tussenkop)"></h1>
				<p v-html="getContent(content.tekst[3].tekst)"></p>
			</div>
		</div>

		<!-- wederhoor -->

		<div class="knd-article vierde">
			<kinesis-container 
				:event='"scroll"' 
				:duration="1"
				class="thomas3-wrapper">
				<kinesis-element 
					:type='"translate"' 
					:axis='"x"'
					:originX="0"
					:maxX="600"
					:strength="500">
					<img :src='require("@/assets/img/thomas3.png")' class="thomas3" />
				</kinesis-element>
			</kinesis-container>

			<div class="knd-text">
				<p v-html="content.intro_wederhoor"></p>
				<h1 v-if="getFonds()">
					Reactie van <span class="wederhoor-fonds">{{ getFonds()['pensioenfonds'] }}</span>
				</h1>
				<p v-if="getFonds()" v-html="getWederhoor()"></p>
			</div>
		</div>

		<!-- uitsmijter -->

		<div class="knd-article vijfde">
			<div class="knd-text">
				<h1 v-html="getContent(content.tekst[4].tussenkop)"></h1>
				<p v-html="getContent(content.tekst[4].tekst)"></p>
			</div>

			<div 
				v-for="(teaser, index) in content.teaser"
				:key="'teaser' + index">
				<Teaser 
					:url="teaser.url" 
					:title="getContent(teaser.titel)" 
					:imgUrl="teaser.afbeelding[0].url" />
			</div>
		</div>

		<!-- colofon -->

		<Colofon />

	</div>
</template>

<script>
	import './story.scss';
	import { KinesisContainer, KinesisElement} from 'vue-kinesis';

	import Swiper from './../swiper/swiper';
	import Pensioenstats from './../pensioenstats/pensioenstats';
	import Pensioenswarms from './../pensioenswarms/pensioenswarms';
	import Colofon from './../colofon/colofon';
	import Pijl from './pijl';
	import Teaser from './../teaser/teaser';

	export default {
		name: 'Story',
		computed: {
		},
		data: function() {
			return {
				content: this.$store.state.content
			}
		},
		mounted() {
			window.setTimeout(() => { //fix zet kinesis elementen goed
				window.scrollTo(0, 1);
			}, 1000);

			window.addEventListener('scroll', () => {
				this.showEarth();
			});

			if (this.content) {
				console.log("content:", this.content);
			}
		},
		methods: {
			geldWeg() {
				const geld = document.querySelectorAll(".geld")

				geld.forEach((plaatje) => {
					plaatje.classList.add("verdwijn");
				});
			},

			showEarth() {
				const ellipse = this.$refs.ellipse;

				if (ellipse) {
					ellipse.style.opacity = 1 - (window.pageYOffset * 0.0015);
				}

				// if (this.content) {
				// 	console.log("content:", this.content);
				// }
			},

			getContent(content) {
				// if (this.$store.state.language === "nl") {
					return content.data;
				// }
				// else {
					// return content[label].data5891;	
				// }


			},

			getFonds() {
				return this.$store.getters.selectedFonds;
			},

			getWederhoor() {
				const thisWederhoor = this.content.wederhoor.filter((d,i) => {
					return d['pensioenfonds'] === this.getFonds()['pensioenfonds'];
				});
				return thisWederhoor[0]['tekst']['data'];
			}
		},
		components: {
			Colofon,
			Pensioenstats,
			Pensioenswarms,
			Swiper,
			Pijl,
			Teaser
		}
	}
</script>